import "./App.css";
import MainCard from "./components/maincard/maincard";

function App() {
  return (
    <>
      <div className="gradient-background">
        <MainCard />
      </div>
    </>
  );
}

export default App;
